'use strict';

angular.module('app')

.run(function (Programme) {}) // jshint ignore:line

.factory('Programme', function (DS, Category) {
    return DS.defineResource({
        name: 'Programme',
        endpoint: 'programmes',
        upsert: true,
        relations: {
            belongsTo: {
                Language: {
                    localField: 'language',
                    localKey: 'language_id'
                },
                Programme: {
                    localField: 'parent',
                    localKey: 'parent_id'
                }
            },
            hasMany: {
                Category: {
                    localField: 'categories',
                    foreignKey: 'programme_id'
                },
                Programme: {
                    localField: 'children',
                    foreignKey: 'parent_id'
                }
            }
        },
        methods: {
            getCategories: function ()
            {
                return Category.filter({
                    sort: 'display_order',
                    where: {
                        programme_id: this.id,
                    }
                });
            }
        }
    });
});
